import { MenuItem } from 'primeng/api'
import { AfterViewInit, Component, Input, OnInit, ViewChild, inject } from '@angular/core'
import { NavigationEnd } from '@angular/router'
import { filter } from 'rxjs'
import { Popover } from 'primeng/popover'
import { AppEventService, EVENT_TYPE } from '../../../services/app-event.service'
import { BaseComponent } from '../../../components/base.component'
import { AuthService } from '../../../services/auth.service'
import { SessionTimerComponent } from '../../../components/session-timer/session-timer.component'
import { Token } from '../../../models/Gateway'
import { AppStateService } from '../../../store/state/app/app.state.service'
import { ZendeskService } from '../../../services/zendesk.service'
@Component({
    selector: 'app-mobile-header',
    templateUrl: './mobile-header.component.html',
    styleUrl: './mobile-header.component.scss',
    standalone: false
})
export class MobileHeaderComponent extends BaseComponent implements OnInit, AfterViewInit {
  #appStateService = inject(AppStateService)

  #authService = inject(AuthService)
  #zendeskService = inject(ZendeskService)

  @Input() items: MenuItem[]
  @ViewChild('mobilemenu') menu: Popover
  @Input() isLoggedIn: boolean
  #eventService: AppEventService = inject(AppEventService)
  tokenInfo: Token;
  @ViewChild(SessionTimerComponent) sessionTimer: SessionTimerComponent;
  filteredMenuItems: MenuItem[] = [];

  ngOnInit(): void {
    this.subscriptions.add(this.router.events.pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        if (this.menu) {
          this.menu.hide()
        }
        // console.log('Current URL:', this.router.url);
        // this.filteredMenuItems = this.items.filter(item => item.id !== '99');
        this.filteredMenuItems = this.mapMenuItems(this.items).filter(item => item.id !== '99');
        console.log(this.filteredMenuItems);
      }))
  }

  ngAfterViewInit(): void {
    this.subscriptions.add(this.#appStateService.tokenSelector$.subscribe({
      next: () => {
        this.tokenInfo = this.#appStateService.getToken();
        if (this.tokenInfo) {
          this.sessionTimer.start(this.tokenInfo.startDate, this.tokenInfo.endDate);
        }
      }
    }));
  }

  onLiveSupportClicked() {
    this.#zendeskService.toggleLiveChat()
  }

  onSessionresume() {
    this.#authService.refreshSession();
  }

  onLogoutClicked() {
    this.#eventService.raiseEvent(EVENT_TYPE.LOGOUT)
  }

  mapMenuItems(items: MenuItem[]): MenuItem[] {
    return items.map(item => {
      const mapped: MenuItem = {
        ...item,
        // remove routerLink completely
        routerLink: undefined,
      };

      if (Array.isArray(item.routerLink) && item.routerLink.length > 0) {
        // Convert routerLink (array or string) → command()
        mapped.command = () => {
          let link = item.routerLink;

          // Normalize routerLink (string → array)
          if (typeof link === 'string') {
            link = [link];
          }

          this.router.navigate(link as any[]);
        };
      }

      // Recursively fix child items
      if (item.items && item.items.length > 0) {
        mapped.items = this.mapMenuItems(item.items);
      }

      return mapped;
    });
  }
}
